module.exports = __webpack_public_path__ + "img/ic_next.4532a4c6.svg";